import { Add, Close, Style } from "@mui/icons-material";
import {
  Box,
  Button,
  Card,
  FormControl,
  IconButton,
  InputLabel,
  ListItem,
  ListItemText,
  MenuItem,
  Select,
  TextField,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { useEffect, useState } from "react";
import useQuickBooksCustomer from "../../../components/NewDetail/useQuickBooksCustomer";
import { useTheme } from "@emotion/react";
import AddQuickbooksCustomerDialog from "./AddQuickbooksCustomerDialog";

const SelectQuickbooksCustomer = ({ qbCustomerId, onSelect }) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const { customers, search, setSearch, category, setCategory, isLoading } =
    useQuickBooksCustomer();
  const [filteredOutSubCustomers, setFilteredOutSubCustomers] = useState([]);
  const [selectedId, setSelectedId] = useState();
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [newCustomerDialogOpen, setNewCustomerDialogOpen] = useState(false);

  const determineName = (customer) => {
    if (customer?.CompanyName) return customer.CompanyName;
    if (customer?.DisplayName) return customer.DisplayName;
    if (customer?.FullyQualifiedName) return customer.FullyQualifiedName;
  };

  useEffect(() => {
    if (customers) {
      setFilteredOutSubCustomers(customers.filter((cust) => !cust.Job));
    }
  }, [customers]);

  useEffect(() => {
    onSelect(selectedCustomer ? selectedCustomer.Id : null);
  }, [selectedCustomer]);

  return (
    <Box>
      {selectedCustomer ? (
        <Card
          sx={{
            padding: "16px",
            display: "flex",
            flexDirection: "row",
            fontWeight: "bold",
            alignItems: "center",
          }}
        >
          <Box sx={{ flex: 1 }}>
            <Typography sx={{ fontWeight: "bold", flex: 1 }}>
              {determineName(selectedCustomer)}
            </Typography>
            <Typography>
              {selectedCustomer.GivenName} {selectedCustomer.FamilyName}
            </Typography>
          </Box>
          <IconButton
            onClick={() => {
              //   action({
              //     type: "UPDATE DETAILS: QB CUSTOMER ID",
              //     payload: {
              //       customerId: null,
              //       salesTermId: null,
              //     },
              //   });
              setSelectedCustomer(null);
            }}
          >
            <Close />
          </IconButton>
        </Card>
      ) : (
        <Card sx={{ marginTop: "16px", padding: "16px" }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <Button
              variant="outlined"
              sx={{ width: "150px", marginRight: "8px" }}
              onClick={() => {
                setNewCustomerDialogOpen(true);
              }}
            >
              <Add /> New
            </Button>
            <Select
              label="Filter"
              sx={{ width: "175px", marginRight: "8px" }}
              size="small"
              select
              value={category}
              onChange={(e) => setCategory(e.target.value)}
            >
              <MenuItem value="DisplayName">Display Name</MenuItem>
              <MenuItem value="CompanyName">Company Name</MenuItem>
              <MenuItem value="FullyQualifiedName">
                Fully Qualified Name
              </MenuItem>
              <MenuItem value="FamilyName">Customer Family Name</MenuItem>
              <MenuItem value="GivenName">Customer Given Name</MenuItem>
            </Select>
            <TextField
              label="Search..."
              size="small"
              fullWidth
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: ".5rem",
              overflow: "auto",
              maxHeight: "300px",
              marginTop: "1rem",
            }}
          >
            {filteredOutSubCustomers.map((cust, index) => (
              <ListItem
                key={index}
                sx={{
                  cursor: "pointer",
                  "&:hover": {
                    background: "#eeeeee",
                  },
                }}
                onClick={() => {
                  console.log("SELECTED", cust);
                  setSelectedCustomer(cust);
                }}
              >
                <ListItemText
                  primary={determineName(cust)}
                  secondary={
                    <Typography>
                      {cust.GivenName} {cust.FamilyName}
                    </Typography>
                  }
                />
              </ListItem>
            ))}
          </Box>
          <AddQuickbooksCustomerDialog
            open={newCustomerDialogOpen}
            onClose={() => {
              setNewCustomerDialogOpen(false);
            }}
            onSaved={(newCustomer) => {
              setSelectedCustomer(newCustomer);
              setNewCustomerDialogOpen(false);
            }}
          />
        </Card>
      )}
    </Box>
  );
};
export default SelectQuickbooksCustomer;
